import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import type { TeamCompetitorMemberSummary } from '../types/api.types';
import { TEAM_COLORS } from '../constants/teamColors';
import { getTeamCompetitors } from '../utils/teamCompetition';

const buildCompetitorRow = (competitor: TeamCompetitorMemberSummary) => (
  <tr key={competitor.memberID}>
    <td style={{ verticalAlign: 'middle', padding: '1px' }}>
      <Link to={`/members/${competitor.memberID}`}>
        <img src={`/assets/${competitor.memberID}.jpg`} height="45px" alt="" />
        <span>{` ${competitor.firstName || ''} ${competitor.surname || ''}`}</span>
      </Link>
      {competitor.captain ? <span> (c)</span> : null}
    </td>
    <td
      style={{ verticalAlign: 'middle' }}
    >{`${competitor.pointsScored || 0} (${competitor.availablePoints || 0})`}</td>
  </tr>
);

interface TeamCompetitionCompetitorsProps {
  results: TeamCompetitorMemberSummary[];
}

export default function TeamCompetitionCompetitors({ results }: TeamCompetitionCompetitorsProps) {
  if (!results || results.length === 0) {
    return <p>No results</p>;
  }

  const usaCompetitors = getTeamCompetitors(results, 'USA');
  const eurCompetitors = getTeamCompetitors(results, 'EUR');

  const usaCompetitorRows = usaCompetitors.map(buildCompetitorRow);

  const eurCompetitorRows = eurCompetitors.map(buildCompetitorRow);

  return (
    <div>
      <Row>
        <Col md={6}>
          <h3 style={{ color: TEAM_COLORS.EUR.hex }}>Team Europe</h3>
          <table className="table">
            <thead>
              <tr>
                <th>Member</th>
                <th>Points</th>
              </tr>
            </thead>
            <tbody>{eurCompetitorRows}</tbody>
          </table>
        </Col>
        <Col md={6}>
          <h3 style={{ color: TEAM_COLORS.USA.hex }}>Team USA</h3>
          <table className="table">
            <thead>
              <tr>
                <th>Member</th>
                <th>Points</th>
              </tr>
            </thead>
            <tbody>{usaCompetitorRows}</tbody>
          </table>
        </Col>
      </Row>
    </div>
  );
}
